import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { TableBaseStyle } from './VibrationSettingStyle';


const VibrationSettingHeader: React.FC = () => {
  const { t } = useTranslation();
  const classes = TableBaseStyle();

  return (
    <TableRow>
      <TableCell className={classes.tableHeader} width={250}>{t('VibrationSettingHeader.種別', '種別')}</TableCell>
      <TableCell className={classes.tableHeader} width={250}>{t('VibrationSettingHeader.上限周波数', '上限周波数(Hz)')}</TableCell>
      <TableCell className={classes.tableHeader} width={250}>{t('VibrationSettingHeader.下限周波数', '下限周波数(Hz)')}</TableCell>
    </TableRow>
  )
};

export default VibrationSettingHeader;